export const createGoogleTag = target =>
  function googleTag() {
    target.dataLayer = target.dataLayer || [];
    // gtag.js requires its command queue to contain Arguments objects. Using
    // a rest parameter here converts commands to arrays and silently stops
    // Firebase Analytics events from reaching the collector.
    // eslint-disable-next-line prefer-rest-params
    target.dataLayer.push(arguments);
  };
